export default __webpack_public_path__ + "static/media/icon-stops.68228721.svg";